import { featureIDs, type Features } from './features.types';

const team = window.Spark?.state.currentTeam;

export const FEATURES: Features = featureIDs.reduce((acc, id) => {
    // eslint-disable-next-line
    const teamAttributes = team?.team_attributes || {};
    acc[id] = Boolean(teamAttributes[id]);
    return acc;
}, {} as Features);
